import { render, staticRenderFns } from "./homeDetails.vue?vue&type=template&id=001cb87c&scoped=true&"
import script from "./homeDetails.vue?vue&type=script&lang=js&"
export * from "./homeDetails.vue?vue&type=script&lang=js&"
import style0 from "./homeDetails.vue?vue&type=style&index=0&id=001cb87c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001cb87c",
  null
  
)

export default component.exports